export default defineNuxtRouteMiddleware(async (to) => {
  const authStore = useAuthStore();

  // If not authenticated, redirect to login page
  if (!authStore.isAuthenticated) {
    if (to.name === "login") {
      return abortNavigation(
        "Loop prevented - this middleware should not be used on the login page"
      );
    }

    return await navigateTo({
      path: "/logg-inn",
    });
  }
});
